
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './xyStatefulSection.html?raw';
import _StatefulSection from '../../moreCore/UI/_StatefulSection/_StatefulSection';
import "../../moreCore/UI/SearchSelect/SearchSelect";

class xyStatefulSection extends compose(_StatefulSection) {
    templateString: any = template;

 
    
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

    }
}

export default mdsWidget(xyStatefulSection);